import React from 'react';

const { protocol, hostname } = window.location;

export const cdnUrl = process.env.REACT_APP_DEBUG
  ? 'https://alp.amsvisa.co.il'
  : `${protocol}//${hostname}`;
export const url = cdnUrl + '/backend';

export const sharedConfig = {
  setUser: () => {},
  setProposals: () => {},
  setLanguage: () => {},
  SliderSearch: () => <></>,
  ProposalModal: () => <></>,
  setFooter: () => {},
  setSiteConfig: () => {},
  SearchBox: () => undefined,
  imgUs: '',
  imgIs: '',
  imgBg: '',
  imgLogo: require('./assets/logo_visa.png'),
  language: '',
  proposals: [],
  cdnUrl,
  defaultMultiSearchConfig: '',
  hideFlags: true,
};

export const paxValidation = {
  firstName: { required: true, minLength: 3, english: true },
  lastName: { required: true, minLength: 3, english: true },
  phone: { required: true },
  email: { required: true, email: true },
};
